import { Component } from '@angular/core';
import { ConfirmModalService } from '../../../services/confirm-modal.service';
import { CardComponent } from '../../ui/card/card.component';

@Component({
  selector: 'app-confirm-modal',
  standalone: true,
  imports: [CardComponent],
  template: `
    <div
      [class]="
        'opacity-0 invisible text-textDefault confirm-modal fixed top-0 left-0 bottom-0 right-0 z-[1001] flex justify-items-center items-center' +
        (confirmModal.confirmModal().show
          ? ' show'
          : confirmModal.confirmModal().show === false
          ? ' hide'
          : '')
      "
    >
      <div
        class="z-[-1] bg-background opacity-90 absolute top-0 right-0 bottom-0 left-0"
      ></div>
      <app-card class="z-1 m-auto min-w-[300px] max-w-[95%]">
        <div class="text-center w-full p-4 text-xl font-bold">
          <h3 class="text-accent">{{ confirmModal.confirmModal().title }}</h3>
        </div>
        <div class="text-center w-full p-4 whitespace-pre-line">
          <p>{{ confirmModal.confirmModal().message }}</p>
        </div>
        <div class="flex w-full p-4">
          @if(confirmModal.confirmModal().inverted) {
          <div class="flex-1 pr-2">
            <button
              class="w-full p-2 border bg-danger text-dangerContrast border-danger rounded-md"
              (click)="confirmModal.confirmModal().confirm?.()"
            >
              {{ confirmModal.confirmModal().confirmOnly ? 'I Understand' : 'Yes' }}
            </button>
          </div>
          @if(!confirmModal.confirmModal().confirmOnly) {
          <div class="flex-1 pl-2">
            <button
              class="w-full p-2 border bg-accent border-accent rounded-md text-accentContrast"
              (click)="confirmModal.confirmModal().cancel?.()"
            >
              Cancel
            </button>
          </div>
          } } @else { @if(!confirmModal.confirmModal().confirmOnly) {
          <div class="flex-1 pr-2">
            <button
              class="w-full p-2 border bg-danger text-dangerContrast border-danger rounded-md"
              (click)="confirmModal.confirmModal().cancel?.()"
            >
              Cancel
            </button>
          </div>
          }
          <div class="flex-1 pl-2">
            <button
              class="w-full p-2 border bg-accent border-primary rounded-md text-accentContrast"
              (click)="confirmModal.confirmModal().confirm?.()"
            >
              {{ confirmModal.confirmModal().confirmOnly ? 'I Understand' : 'Yes' }}
            </button>
          </div>
          }
        </div>
      </app-card>
    </div>
  `,
  styleUrl: `confirm-modal.component.scss`,
})
export class ConfirmModalComponent {
  constructor(public confirmModal: ConfirmModalService) {}
}
